import { getUrl } from "./helper";
import { authedFunction } from "../session";

export const siteConfigActions = {
	// ============================================
	// Template Retrieval (Site Builder Wizard)
	// ============================================

	/**
	 * Get templates available from the Pluss Org account
	 * Returns { configured: boolean, templates: Array, message?: string }
	 */
	getOrgTemplates: () => {
		return authedFunction({
			method: "GET",
			url: getUrl("siteconfigs", "get/config/orgtemplates"),
		});
	},

	/**
	 * Get template content from the Pluss Org account
	 * Returns the complete template configuration for wizard display
	 * @param {string} templateId - ID of the template to fetch
	 * @returns {Promise} - { success, template: { branding, featurePicker, appViews, userTypes, ... } }
	 */
	getTemplateFromOrg: (templateId) => {
		return authedFunction({
			method: "GET",
			url: getUrl("siteconfigs", "get/config/fromorg", { id: templateId }),
		});
	},

	/**
	 * Get template from an existing site
	 * Returns the same canonical format as getTemplateFromOrg
	 * @param {string} siteId - ID of the site to extract config from
	 * @returns {Promise} - { success, template: { branding, featurePicker, appViews, userTypes, ... } }
	 */
	getTemplateFromSite: (siteId) => {
		return authedFunction({
			method: "GET",
			url: getUrl("siteconfigs", "get/config/fromsite", { siteId }),
		});
	},

	// ============================================
	// Job Management (Site Builder Wizard)
	// ============================================

	/**
	 * Start a new configuration job
	 * @param {string} type - Job type (e.g., "site-creation")
	 * @param {object} input - Job-type-specific input data
	 * @returns {Promise} - { success, jobId, status }
	 */
	startJob: (type, input) => {
		return authedFunction({
			method: "POST",
			url: getUrl("siteconfigs", "jobs/start"),
			data: { type, input },
		});
	},

	/**
	 * Get job status for polling
	 * @param {string} jobId - Job ID to check
	 * @returns {Promise} - { success, jobId, type, status, currentStep, steps, output?, error? }
	 */
	getJobStatus: (jobId) => {
		return authedFunction({
			method: "GET",
			url: getUrl("siteconfigs", `jobs/status/${jobId}`),
		});
	},

	// ============================================
	// Config Transfer (Site Config Transfer Tool)
	// ============================================

	/**
	 * Apply a transferred site config to a target site
	 * @param {string} siteId - Target site ID
	 * @param {object} config - The full transfer envelope { _version, config: {...} }
	 * @returns {Promise} - { success, applied: [], skipped: [], errors: [] }
	 */
	applySiteConfigTransfer: (siteId, config) => {
		return authedFunction({
			method: "POST",
			url: getUrl("siteconfigs", "update/config/applytransfer"),
			data: { siteId, config },
		});
	},
};
